<template>
  <div>
    <v-row class="mt-5">
      <v-col>
        <section>
          <line-chart
            class="mb-5"
            :raw-data="playersSprintSorted"
            :chart-value-keys="[{key: getVariableName('CALETLDLSP'), type: 'bar', label: $t('diagnostic_groups.sprint')}, {key: getVariableName('CALETLDLHSR'), type: 'bar', label: 'HSR'}]"
            x-value="last_name"
            y-value-prefix="latest_stats."
            :yaxis="[ { title: { text: $t('card_title.sprint_distance') }} ]"
            :xaxis="{
              labels: {
                rotate: -45
              },
              categories: playersSprintSorted.map(p => p.first_name + ' ' + p.last_name),
              tickPlacement: 'between'
            }"
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.sprint_and_hsr') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
      <v-col>
        <section>
          <line-chart
            class="mb-5"
            :raw-data="playersDecelerationSorted"
            :chart-value-keys="[ {key: getVariableName('CAPGCSACB13EG2'), type: 'bar', label: $t('chart_legends.accelerations_more_4')}, {key: getVariableName('CAPGCSDCB13EG2'), type: 'bar', label: $t('chart_legends.deceleration_less_-4')}]"
            x-value="last_name"
            y-value-prefix="latest_stats."
            :yaxis="[ { title: { text: $t('chart_legends.number_of_occasions') }} ]"
            :xaxis="{
              labels: {
                rotate: -45
              },
              categories: playersDecelerationSorted.map(p => p.first_name + ' ' + p.last_name),
              tickPlacement: 'between'
            }"
            :colors="['#FF4560', '#775DD0']"
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.accelerations_and_decelerations') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <section>
          <line-chart
            class="mb-5"
            :raw-data="playersTotalDistanceSorted"
            type="bar"
            :chart-value-keys="[{key: getVariableName('UXPCSTD'), type: 'bar', label: $t('card_title.total_distance')},]"
            x-value="last_name"
            y-value-prefix="latest_stats."
            :yaxis="[ { title: { text: $t('card_title.total_distance') }} ]"
            :xaxis="{
              labels: {
                rotate: -45
              },
              categories: playersTotalDistanceSorted.map(p => p.first_name + ' ' + p.last_name),
              tickPlacement: 'between'
            }"
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.total_distance') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
      <v-col>
        <section>
          <line-chart
            class="mb-5"
            :raw-data="playersExplosiveEffortSorted"
            type="bar"
            :chart-value-keys="[{key: getVariableName('UXPCSEEF'), type: 'bar', label: $t('card_title.explosive_efforts')}]"
            x-value="last_name"
            y-value-prefix="latest_stats."
            :yaxis="[ { title: { text: $t('card_title.explosive_efforts') }} ]"
            :xaxis="{
              labels: {
                rotate: -45
              },
              categories: playersExplosiveEffortSorted.map(p => p.first_name + ' ' + p.last_name),
              tickPlacement: 'between'
            }"
            :colors="['#775DD0']"
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('gps_variables.explosive_efforts') }}
                </div>
              </v-card-title>
            </template>
          </line-chart>
        </section>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <section>
          <scatter-chart
            class
            :series="players.map(p => {
              return {
                name: p.last_name + ', ' + p.first_name,
                data: [
                  [ p.latest_stats[getVariableName('UXPCSEEF')] || 0, p.latest_stats[getVariableName('UXHSRmin')] || 0 ]
                ]
              }
            })"
            :xaxis="{
              tickAmount: 10,
              min: 0,
              max: maxValues[getVariableName('UXPCSEEF')]
            }"
            :annotations="{
              xaxis: [{
                x: (maxValues[getVariableName('UXPCSEEF')] || 0) / 2,
                strokeDashArray: 0,
                borderColor: '#008FFB',
              }],
              yaxis: [{
                y: (maxValues[getVariableName('UXHSRmin')] || 0) / 2,
                strokeDashArray: 0,
                borderColor: '#008FFB'
              }]
            }"
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <v-row
                  dense
                  align="center"
                >
                  <v-col class="text-no-wrap">
                    <div class="subtitle-2 grey--text text--grey-100">
                      {{ $t('card_title.team_explosive_vs_hsr_min') }}
                    </div>
                  </v-col>
                </v-row>
              </v-card-title>
            </template>
          </scatter-chart>
        </section>
      </v-col>
      <v-col>
        <section>
          <scatter-chart
            class
            :series="players.map(p => {
              return {
                name: p.last_name + ', ' + p.first_name,
                data: [
                  [ p.latest_stats[getVariableName('UXPCSTD')] || 0, p.latest_stats[getVariableName('CALETLDLHSR')] || 0 ]
                ]
              }
            })"
            :xaxis="{
              tickAmount: 10,
              min: 0,
              max: maxValues[getVariableName('UXPCSTD')]
            }"
            :annotations="{
              xaxis: [{
                x: (maxValues[getVariableName('UXPCSTD')] || 0) / 2,
                strokeDashArray: 0,
                borderColor: '#008FFB',
              }],
              yaxis: [{
                y: (maxValues[getVariableName('CALETLDLHSR')] || 0) / 2,
                strokeDashArray: 0,
                borderColor: '#008FFB'
              }]
            }"
          >
            <template v-slot:header>
              <v-card-title class="pa-6">
                <v-row
                  dense
                  align="center"
                >
                  <v-col class="text-no-wrap">
                    <div class="subtitle-2 grey--text text--grey-100">
                      {{ $t('card_title.team_total_dist_vs_hsr') }}
                    </div>
                  </v-col>
                </v-row>
              </v-card-title>
            </template>
          </scatter-chart>
        </section>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import LineChart from '@/components/charts/LineChart.vue'
import ScatterChart from '@/components/charts/ScatterChart.vue'
import { orderBy } from 'lodash'

export default {
  name: 'TrainingLoadGpsGraphs',
  components: { ScatterChart, LineChart },
  props: {
    players: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      default: 'total'
    },
    maxValues: {
      type: Object,
      required: true
    }
  },
  computed: {
    playersSprintSorted() {
      return orderBy(this.players, [(player) => this.sortingCriteria(player, 'CALETLDLSP'),
        (player) => this.sortingCriteria(player, 'CALETLDLHSR')], ['desc', 'desc'])
    },
    playersDecelerationSorted() {
      return orderBy(this.players, [(player) => this.sortingCriteria(player, 'CAPGCSDCB13EG2'),
        (player) => this.sortingCriteria(player, 'CAPGCSACB13EG2')], ['desc', 'desc'])
    },
    playersTotalDistanceSorted() {
      return orderBy(this.players, (player) => this.sortingCriteria(player, 'UXPCSTD'), ['desc'])
    },
    playersExplosiveEffortSorted() {
      return orderBy(this.players, (player) => this.sortingCriteria(player, 'UXPCSEEF'), ['desc'])
    }
  },
  methods: {
    getVariableName(variable) {
      let insert = ''

      if (this.type === 'last7days') insert = '_7'
      else if (this.type === 'last30days') insert = '_30'
      else if (this.type === 'wc') insert = '_WC'
      else if (this.type === 'acwr') insert = '_ACWR'
      else if (this.type === 'mon') insert = '_MON'

      return variable + insert
    },
    sortingCriteria(player, parameter) {
      return player.latest_stats[this.getVariableName(parameter)] === null ? -1 : player.latest_stats[this.getVariableName(parameter)]
    }
  }
}
</script>
